<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pbottom-10">
        <DataFilter
                :prime="!$root.isEmbeddedMode ? {title: 'Projects.add'} : undefined"
                :search="{}"
                :right="filtersCtrls"
                :filters="filters"
                v-on:prime="createProject"
                v-on:change="handleInput"
        />
      </div>
      <div style="clear: both;"></div>
      <card body-class="no-padding table-responsive">
        <pagedlist
          :offset="filters.offset"
          :limit="filters.limit"
          :count="filters.count"
          :pages="filters.pages"
          v-on:refresh="refresh"
        >
          <DataTable :columns="columns" :data="table.body" v-on:refresh="refresh" >
            <template v-slot:default="{row, col}">
              <template v-if="col.id === 'transactionnum'">
                <a v-on:click="openOrder(row.ID)">{{ row.transactionnum }}</a>
              </template>
              <template v-else-if="col.id === 'reference'">{{ row.reference }}</template> <!-- <a v-if="row.project" v-on:click="openProject(row.project)">{{ row.reference }}</a> -->
              <template v-else-if="col.id === 'extRef'">{{ row.extRef }}</template> <!-- <a v-if="row.project" v-on:click="openProject(row.project)">{{ row.reference }}</a> -->
              <span v-else-if="col.id === 'workflow'">
                <workflow-badge :workflow="row.workflow"/>
              </span>
              <template v-else-if="col.id === 'date'">{{ row.date | formatDate }}</template>
              <template v-else-if="col.id === 'duedate'">{{ row.duedate | formatDate }}</template>
              <template v-else-if="col.id === 'supplier'" class="a-r">{{ row.supplierName }}</template>
              <template v-else-if="col.id === 'amount'" class="a-r">{{ row.netamount | formatCurrency }}</template>
              <span v-else-if="col.id === 'status'">
                <order-status-badge :order="row"/>
              </span>
            </template>
          </DataTable>
        </pagedlist>
      </card>

      <div class="ptop-20">
        <button type="button" class="btn btn-primary" v-on:click="createProject" v-if="!$root.isEmbeddedMode"><i class="fa fa-plus"></i> {{ $t('Projects.add') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
  import NewProject from './NewProject.vue'
  import DataTable from '../Elements/DataTable.vue';
  import DataFilter from '../Elements/DataFilter.vue';
  import OrderStatusBadge from '../Elements/OrderStatusBadge';
  import WorkflowBadge from '../Elements/WorkflowBadge';

var view = require('../view.js'),
    viewData = {
      filters: {
        offset: 0,
        limit: 20,
        count: 0,
        pages: 0,
        status: '',
        search: '',
        orderby: 'transactionnum'
      },
      columns: [
        {
          id: 'transactionnum',
          label: 'Orders.orderNum',
          sortable: true,
        },{
          id: 'reference',
          label: 'Orders.projectRef',
          sortable: true,
        },{
          id: 'extRef',
          label: 'Orders.extRef',
          sortable: true,
        },{
          id: 'workflow',
          label: 'Projects.projectType',
          sortable: false,
        },{
          id: 'date',
          label: 'Common.date',
          sortable: true,
        },{
          id: 'duedate',
          label: 'ProjectDetails.estimatedDelivery',
          sortable: true,
        },{
          id: 'supplier',
          label: 'ProjectDetails.supplierName',
          sortable: true,
        },{
          id: 'amount',
          label: 'Common.amount',
          sortable: false,
        },{
          id: 'status',
          label: 'Common.status',
          sortable: false,
        }
      ],
      table: {
        body: []
      },
      workflows: [],
    };

export default view(viewData, {
  components: {
    NewProject,
    DataTable,
    DataFilter,
    OrderStatusBadge,
    WorkflowBadge,
  },
  computed: {
    orderStatuses() {
      if (this.filters.workflow && Array.isArray(this.$root.workflowTypes[this.filters.workflow].orderStatuses)) {
        return [
          {label: 'Orders.statusAll', value: '', alias: 'all', conditions: {}},
          ...this.$root.workflowTypes[this.filters.workflow].orderStatuses.map((x, index) => ({
            label: x.label,
            value: JSON.stringify(x.conditions),
          }))
        ];
      }

      return Array.isArray(this.$root.orderStatuses) ? this.$root.orderStatuses : [
        {label: 'Orders.statusAll', value: '', alias: 'all'},
        {label: 'Orders.statusReceived', value: 0, alias: 'received'},
        {label: 'Orders.statusInProgress', value: 1, alias: 'inprogress'},
        {label: 'Orders.statusCancelled', value: 3, alias: 'cancelled'},
        {label: 'Orders.statusCompleted', value: 4, alias: 'completed'},
        {label: 'Orders.statusDelivered', value: 12, alias: 'delivered'},
        {label: 'Orders.statusInvoiced', value: 16, alias: 'invoiced'}
      ];
    },
    orderColumn() {
      if (viewData.filters.orderby.startsWith('-')) {
        return viewData.filters.orderby.substring(1)
      }
      return viewData.filters.orderby;
    },
    isStatusPickerAvailable() {
      if (Object.values(this.$root.workflowTypes).some(x => x.orderStatuses)) {
        if (!this.filters.workflow) {
          return false;
        }
      }

      if (this.$parent.viewIndex == null || this.$parent.viewIndex === '') {
        return true
      }
      return isNaN(parseInt(this.$parent.viewIndex, 10)) && this.$parent.viewIndex && this.$parent.viewIndex.indexOf('status:') < 0;
    },
    isWorkflowPickerAvailable() {
      return true;
    },
    filtersCtrls() {
      let x = [];
      if (this.isWorkflowPickerAvailable) {
        x.push({
          id: 'workflow',
          options: this.workflows,
          placeholder: 'Projects.projectType'
        })
      }

      if (this.isStatusPickerAvailable) {
        x.push({
          id: 'status',
          options: this.orderStatuses,
          placeholder: 'Common.status'
        })
      }

      return x;
    },
  },
  mounted() {
    this.$parent.viewTitle = this.$t('Orders.title');

    this.filters = Object.assign({}, this.filters, this.parseFilters());
    this.filters.orderby = this.filters.orderby || 'transactionnum';

    this.workflows = Object.entries(this.$root.workflowTypes || {})
            .filter(([_, def]) => def.visibility !== false && def.locked !== true)
            .map(([type, def]) => {
              return {
                value: type,
                label: this.$t(def.title),
              }
            });

    this.columns = viewData.columns.filter(x => this.isEnabled(x.id));

    this.refresh();
  },
  methods: {
    async refresh(offset, orderby) {
      if (orderby) {
        this.filters.orderby = orderby
      }

      let params = Object.assign({}, this.filters);

      if (offset != null)
        params.offset = offset;

      const status = typeof params.status === 'string' && params.status.startsWith('{') ? JSON.parse(params.status) : {status: params.status};

      delete params.status;
      delete params.count;
      delete params.pages;

      params = Object.assign(status, params);

      Object.entries(params)
        .filter( ([, param]) => param == null || param === '')
        .forEach(([key]) => {
          delete params[key];
        });

      Object.keys(params).forEach(key => {
        if (Array.isArray(params[key])) {
          params[key] = params[key].join('|')
        }
      })

      try {
        const {data} = await this.$http.get(this.$root.url + 'order/', {params})
        this.table.body = data.result.data;
        this.filters.count = data.result.count;
        this.filters.offset = data.result.offset;
        this.filters.limit = data.result.limit;
        this.filters.pages = data.result.pages;
      } catch (res) {
        this.table.body = [];
        console.log('Fail', res);
      }
    },
    parseFilters() {
      const filter = this.$parent.viewIndex;
      if (filter == null) {
        return {};
      }

      if (Array.isArray(viewData.status)) {
        for (let i = 0 ; i < viewData.status.length ; i++) {
          if (viewData.status[i].alias === this.$parent.viewIndex) {
            return {
              status: viewData.status[i].value,
              tag: '',
            };
          }
        }
      }

      return Object.assign({
          status: '',
          tag: '',
        }, ...filter.split(',')
          .map(filter => filter.split(':'))
          .filter(x => x.length === 2)
          .map(([key, value]) => ({
            [key]: isNaN(parseInt(value, 10)) || (parseInt(value, 10) != value) ? value : parseInt(value, 10)
          }))
      );
    },
    handleInput(id) {
      console.log('id', id);
      if (id === 'workflow') {
        viewData.filters.status = null;
      }
      this.$forceUpdate();
      this.refresh(0);
    },
    handleSearch() {
      // this.$refs.txtSearch.focus();
      this.handleInput();
    },
    resetSearch() {
       viewData.filters.search = '';
       this.handleInput();
    },
    openOrder(ID) {
      if (typeof ID == 'number') {
        this.$parent.openView('OrderDetails', ID);
      }
    },
    createProject() {
      this.$parent.$refs.newProject.openDialog();
    },
    openProject(ID) {
      this.$parent.openView('ProjectDetails', ID);
    },
    onHeaderClick(columnName) {
      if (columnName) {
        if (columnName === this.orderColumn) {
          viewData.filters.orderby = (viewData.filters.orderby.startsWith('-') ?  '' : '-') + this.orderColumn;
        } else {
          viewData.filters.orderby = '-' + columnName;
        }
        this.refresh(0);
      }
    },
    isEnabled(column) {
      return !Array.isArray(this.$root.orderColumns) || this.$root.orderColumns.indexOf(column) >= 0;
    }
  }
});
</script>

<style scoped>
  th.sortable {
    cursor: pointer;
  }
</style>
